import "../../styles/SectionTop.css"
import {getIcon} from "../../utils/helper";

const SectionTop = () => {
    const cards = [
        {
            label: "Hauptgericht",
            image: "assets/images/service-5.jpeg",
            link:"/speisekarte",
        },
        {
            label: "Vorspeise",
            // image: "assets/images/service-2.jpg"
            image: "assets/images/service-4.jpeg",
            link:"/speisekarte",
        },
        {
            label: "Getränke",
            image: "assets/images/service-3.jpg",
            link:"/speisekarte",
        },
    ]
    return (
        <div className={"container"}>
            <div className="section service bg-black-10 text-center">
                <div className="content-header">
                    <p className="label-2 section-subtitle slider-reveal">{"Flavors For Royalty"}</p>
                    <div className="icon-separator">
                        {getIcon("separator")}
                    </div>
                    <h2 className="headline-1 section-title">Wir bieten erstklassige Qualität</h2>
                    <p className="section-text">
                        Im Ha Mi Restaurant vereinen wir das Beste aus zwei kulinarischen Welten: die Raffinesse
                        europäischer Küche mit der Vielfalt und Frische asiatischer Spezialitäten. Bei uns steht
                        Qualität an oberster Stelle – von sorgfältig ausgewählten Zutaten über kreative, liebevoll
                        zubereitete Gerichte bis hin zu einem freundlichen und aufmerksamen Service. Erleben Sie bei uns
                        eine Geschmackskomposition, die Tradition und Moderne miteinander verbindet und jeden Besuch zu
                        etwas Besonderem macht.

                    </p>
                </div>
                <ul className="grid-list">
                    {cards?.map((card) => {
                        return <li>
                            <div className="service-card">

                                <div className="has-before hover:shine">
                                    <figure className="card-banner img-holder"
                                            style={{"--width": 285, "--height": 336}}>
                                        <img src={card?.image} width="285" height="336" loading="lazy"
                                             alt="Breakfast" className="img-cover"/>
                                    </figure>
                                </div>

                                <div className="card-content">

                                    <h3 className="title-4 card-title">
                                        {card?.label}
                                    </h3>

                                    <a href={card?.link} className="btn-text hover-underline label-2">Speisekarte</a>

                                </div>

                            </div>
                        </li>
                    })}


                </ul>
                <img src="/assets/images/shape-2.png" width="343" height="345" loading="lazy" alt="shape"
                     className="shape shape-2 move-anim"/>
                <img src="/assets/images/shape-1.png" width="246" height="412" loading="lazy" alt="shape"
                     className="shape shape-1 move-anim"/>
            </div>
        </div>
    )
}
export default SectionTop